import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="relative w-full bg-background-50 py-20 md:py-28">
      <div className="w-full max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Left - Label */}
          <div className="lg:w-[30%]">
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 uppercase tracking-wider">
              <span className="w-2 h-2 rounded-full bg-primary-500"></span>
              À Propos de Hipobuy
            </span>
          </div>

          {/* Right - Content */}
          <div className="lg:w-[70%]">
            <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-950 leading-tight mb-6">
              Hipobuy Spreadsheet révolutionne la gestion de données pour les professionnels
            </h2>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8">
              <strong>Hipobuy Spreadsheet</strong> révolutionne la gestion de données pour les
              professionnels de l&apos;e-commerce européen. Conçu comme une alternative
              intelligente aux tableurs obsolètes, notre outil combine l&apos;esthétique
              minimaliste scandinave avec une puissance analytique sans précédent. Que vous
              gériez un catalogue de chaussures, de hoodies ou d&apos;accessoires rares,
              <strong> Hipobuy Spreadsheet</strong> transforme chaque cellule en une décision
              stratégique. Optimisé pour le référencement naturel et l&apos;expérience
              utilisateur, ce tableur nouvelle génération redéfinit les standards de
              productivité pour les entreprises modernes.
            </p>

            {/* Features mini-grid */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-10">
              <div className="text-center p-5 rounded-xl bg-background-100/80 border border-background-200/60">
                <div className="w-11 h-11 flex items-center justify-center mx-auto mb-3 rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-flashlight-line text-lg"></i>
                </div>
                <p className="text-3xl font-heading font-bold text-foreground-950">15+</p>
                <p className="text-xs text-foreground-500 mt-1">Catégories Produits</p>
              </div>
              <div className="text-center p-5 rounded-xl bg-background-100/80 border border-background-200/60">
                <div className="w-11 h-11 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-user-star-line text-lg"></i>
                </div>
                <p className="text-3xl font-heading font-bold text-foreground-950">10K+</p>
                <p className="text-xs text-foreground-500 mt-1">Utilisateurs Actifs</p>
              </div>
              <div className="text-center p-5 rounded-xl bg-background-100/80 border border-background-200/60">
                <div className="w-11 h-11 flex items-center justify-center mx-auto mb-3 rounded-full bg-secondary-300 text-secondary-700">
                  <i className="ri-shield-check-line text-lg"></i>
                </div>
                <p className="text-3xl font-heading font-bold text-foreground-950">99%</p>
                <p className="text-xs text-foreground-500 mt-1">Uptime Garanti</p>
              </div>
              <div className="text-center p-5 rounded-xl bg-background-100/80 border border-background-200/60">
                <div className="w-11 h-11 flex items-center justify-center mx-auto mb-3 rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-customer-service-2-line text-lg"></i>
                </div>
                <p className="text-3xl font-heading font-bold text-foreground-950">24/7</p>
                <p className="text-xs text-foreground-500 mt-1">Support Client</p>
              </div>
            </div>

            {/* Link to article */}
            <div className="mt-10">
              <Link
                to="/article/hipobuy-spreadsheet-guide-complet"
                className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors group"
              >
                En savoir plus sur Hipobuy Spreadsheet
                <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}